export default class BlogPostsList extends HTMLElement {
  connectedCallback() {
    this.reorderArticles();
  }

  /**
   * Reorders articles to remove white space caused by featured articles
   */
  reorderArticles() {
    const articles = this.querySelectorAll('article');

    let orderData = [
      {
        orderedElements: [],
        rowsQty: 3,
        property: '--desktop-order'
      },
      {
        orderedElements: [],
        rowsQty: 2,
        property: '--mobile-order'
      }
    ];

    for (const orderRow of orderData) {
      for (const article of articles) {
        let newOrder = orderRow.orderedElements.length;

        if (article.hasAttribute('data-featured-article')) {
          if (newOrder % orderRow.rowsQty === 0) {
            orderRow.orderedElements.push(article);
            orderRow.orderedElements.push(true);
          } else {

            let newPosition = Math.floor(newOrder / orderRow.rowsQty) * orderRow.rowsQty;
            orderRow.orderedElements.splice(newPosition, 0, article, true);

          }
        } else {
          orderRow.orderedElements.push(article);
        }
      }

      orderRow.orderedElements = orderRow.orderedElements.filter(value => value !== true);

      for (let i = 0; i < orderRow.orderedElements.length; i++) {
        const article = orderRow.orderedElements[i];
        article.style.setProperty(orderRow.property, i);
      }
    }

    this.classList.remove('opacity-0');
    this.classList.add('opacity-100');
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
